module.exports = __webpack_public_path__ + "img/per08.83fa24d0.png";